<template>
  <div>
    <h3>Coupon bonus</h3>
    <p>Le bonus sur le coupon de bonus est débité immédiatement après l'activation, à condition que le joueur ne dispose pas actuellement d'un bonus actif. Si l'activation n'a pas été effectuée (par exemple, s'il existe un bonus actif), le coupon peut être activé plus tard.</p>
    <p>Chaque bonus est fourni sous certaines conditions et avec certaines restrictions qui doivent être respectées pour pouvoir retirer des fonds de bonus du compte. Selon le type de bonus offert, il se peut que vous deviez remplir certaines conditions pour pouvoir retirer du compte les résultats positifs du pari obtenu en utilisant le bonus.</p>

    <h5>Règles et conditions</h5>
    <ol>
      <li>Tant que les conditions de mise ne sont pas remplies, le retrait des fonds n'est pas possible.</li>
      <li>
        Conditions de mise
        <ul>
          <li v-if="redPipe">
            Casino: {{redPipe.contributionPercent}}% de chaque enjeu n'excédant pas
            <template v-for="cs in redPipe.currencySettings">
              {{cs.maxBet | currency(cs.currency)}} pour {{cs.currency}},
            </template>
          </li>
          <li v-if="flg">
            Jeux Live: {{flg.contributionPercent}}% de chaque enjeu n'excédant pas
            <template v-for="cs in flg.currencySettings">
              {{cs.maxBet | currency(cs.currency)}} pour {{cs.currency}},
            </template>
          </li>
          <li v-if="bk">
            Sport: {{bk.contributionPercent}}% de chaque enjeu n'excédant pas
            <template v-for="cs in bk.currencySettings">
              {{cs.maxBet | currency(cs.currency)}} pour {{cs.currency}},
            </template>
            avec un coefficient >= {{bk.minFactor}}
          </li>
          <li v-if="hdRaces">
            Sports virtuels: {{hdRaces.contributionPercent}}% de chaque enjeu n'excédant pas 
            <template v-for="cs in hdRaces.currencySettings">
              {{cs.maxBet | currency(cs.currency)}} pour {{cs.currency}},
            </template>
            avec un coefficient >= {{hdRaces.minFactor}}
          </li>
        </ul>
      </li>
      <li>L'offre ne peut être jumelée à d'autres promotions ou offres spéciales.</li>
      <li>Un seul bonus est disponible pour un utilisateur, une famille, une adresse, un ordinateur partagé, une adresse IP commune, des données de compte identiques, telles qu'une adresse e-mail, un compte bancaire, des informations de carte de crédit, un compte système de paiement. Toute violation des règles du programme de bonus entraînera la fermeture du compte.</li>
      <li>Le bonus misé est transféré sur le compte principal à hauteur du solde du fonds bonus, mais pas plus de {{bonus.convertToRealMaxPercent}}% de la valeur initiale du bonus.</li>
      <li>Lors du retrait d’argent, le bonus est annulé.</li>
      <li>Les règles de promotion sont sujettes à changement.</li>
    </ol>
  </div>
</template>
<script>
  import Vue from "vue";

  export default {
    name: 'bonus-rules-coupon-fr',
    props: {
      bonus: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
          redPipe: null,
          flg: null,
          bk: null,
          hdRaces: null
      }
    },
    computed: {
      currency() {
        let player = Vue.state.player.get();
        return player && player.balance && player.balance.currency;
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.redPipe = this.bonus.providers.filter(p => p.provider == 'redpipe')[0];
        this.flg = this.bonus.providers.filter(p => p.provider == 'flg')[0];
        this.bk = this.bonus.providers.filter(p => p.provider == 'bk')[0];
        this.hdRaces = this.bonus.providers.filter(p => p.provider == 'hdraces')[0];
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-coupon/fr.vue